import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useShareFormationUrl(): useShareFormationUrlReturn {
  return useLazyContext(ShareFormationUrlContext);
}

export type useShareFormationUrlReturn = {
  generateShareFormationUrl: (id: string) => string;
  decodeShareFormationUrl: (url: string) => DecodedShareFormationUrlResult;
  isSharedFormationUrl: (url: string) => boolean;
};

export type DecodedShareFormationUrlResult =
  | {
      formation: Board;
      id: undefined;
      strippedUrl: string;
    }
  | {
      formation: undefined;
      id: string;
      strippedUrl: string;
    };

export const ShareFormationUrlContext =
  createContext<LazyValue<useShareFormationUrlReturn>>(undefined);

export class NoSharedFormationInUrlError extends Error {
  constructor() {
    super("No shared formation found in the URL");
    this.name = NoSharedFormationInUrlError.name;
  }
}
